// Hoeveel van een schuin x-aslabel past in de strook die de as ervoor reserveert.
//
// AngledAxisTick zet het label 8px onder de tick en draait het 35°. Een label dat
// langer is dan de strook steekt eronder uit en loopt over de legenda heen; dat
// werd zichtbaar toen legenda's niet meer op 100px werden afgekapt (Herstelruimte
// Emmen, Analyseren → Onderzoeken, 2026-10-06). De as rekent zijn hoogte zelf
// niet uit, dus het label past zich aan de hoogte aan, niet andersom.
// AI-CONTEXT: See docs/pitfalls.md#ui-container-class-is-a-scroll-box

const ANGLE_DEG = 35
// recharts zet de tick 8px onder de as (tickSize 6 + tickMargin 2), het label
// zakt daarna 8px (dy in AngledAxisTick), plus 3px voor de staart van letters
// als g en j. Nagemeten in de browser, 2026-10-06. Wijzig je de dy, wijzig dan
// dit getal mee — AngledAxisTick.test.jsx toetst dat ze bij elkaar horen.
export const LABEL_DY_PX = 8
const OFFSET_PX = 8 + LABEL_DY_PX + 3
// Breedste gemeten gemiddelde tekenbreedte van Poppins op 10px
// (.angled-axis-tick): 5,2–6,3px per teken over twaalf echte labels.
const CHAR_WIDTH_PX = 6.3
const MIN_CHARS = 6
const ELLIPSIS = '…'
// ' (1)', ' (12)': het volgnummer dat meetmomenten van elkaar onderscheidt.
const SEQUENCE_SUFFIX = /\s*\(\d+\)$/

/**
 * @param {number} [axisHeight] - `height` van de XAxis, zoals recharts hem aan de tick doorgeeft
 * @returns {number} Het aantal tekens dat schuin in die hoogte past
 */
export const maxCharsForAxisHeight = (axisHeight) => {
    const height = Number(axisHeight) || 0
    const verticalPerChar = CHAR_WIDTH_PX * Math.sin((ANGLE_DEG * Math.PI) / 180)
    return Math.max(MIN_CHARS, Math.floor((height - OFFSET_PX) / verticalPerChar))
}

/**
 * @typedef {object} FittedLabel
 * @property {string} text - Wat er op de as komt te staan
 * @property {boolean} truncated - Of het label is ingekort (dan hoort de volledige tekst in een `<title>`)
 */

/**
 * @param {string|number|null|undefined} value - Het volledige label
 * @param {number} [axisHeight] - `height` van de XAxis
 * @returns {FittedLabel}
 */
const fitAngledAxisLabel = (value, axisHeight) => {
    const label = value === undefined || value === null ? '' : String(value)
    const max = maxCharsForAxisHeight(axisHeight)
    if (label.length <= max) return { text: label, truncated: false }

    const match = label.match(SEQUENCE_SUFFIX)
    const suffix = match ? match[0].trim() : ''
    const tail = suffix ? `${ELLIPSIS} ${suffix}` : ELLIPSIS
    const head = match ? label.slice(0, match.index) : label
    const room = Math.max(1, max - tail.length)
    return { text: `${head.slice(0, room).trimEnd()}${tail}`, truncated: true }
}

export default fitAngledAxisLabel
